var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "add-label-dialog",
          style:
            _vm.myType == 2 || _vm.myType == 5
              ? "margin-top:0vh;"
              : "margin-top:4vh;",
          attrs: {
            title: _vm.titleName,
            visible: _vm.dialogVisable,
            "modal-append-to-body": false,
            width: "850px",
            height: "504px",
            "close-on-click-modal": false
          },
          on: {
            close: _vm.closeDialog,
            "update:visible": function($event) {
              _vm.dialogVisable = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "row" }, [
                _c("span", { staticClass: "required" }, [_vm._v("*")]),
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.myType == 5 ? "消息名称" : "SOP名称"))
                ]),
                _c(
                  "div",
                  [
                    _vm._t("value", function() {
                      return [
                        [
                          _c("el-input", {
                            staticStyle: { width: "280px" },
                            attrs: {
                              type: "text",
                              placeholder:
                                _vm.myType == 5
                                  ? "输入群发消息名称"
                                  : "输入SOP名称",
                              maxlength: "30",
                              size: "small",
                              "show-word-limit": ""
                            },
                            model: {
                              value: _vm.sopName,
                              callback: function($$v) {
                                _vm.sopName = $$v
                              },
                              expression: "sopName"
                            }
                          })
                        ]
                      ]
                    })
                  ],
                  2
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c("span", { staticClass: "required" }, [_vm._v("*")]),
                _c("span", { staticClass: "label" }, [_vm._v("选择员工")]),
                _c(
                  "div",
                  { staticClass: "staff-select-wrap" },
                  [
                    _vm._t("value", function() {
                      return [
                        [
                          _c("el-input", {
                            staticClass: "my-select",
                            staticStyle: { width: "150px" },
                            attrs: {
                              type: "text",
                              readonly: "",
                              placeholder: "添加成员",
                              "suffix-icon": "el-icon-arrow-down",
                              size: "small",
                              "show-word-limit": ""
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.selectStaff()
                              }
                            },
                            model: {
                              value: _vm.selectNum,
                              callback: function($$v) {
                                _vm.selectNum = $$v
                              },
                              expression: "selectNum"
                            }
                          }),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.myType == 2 &&
                                    _vm.selectMemberNames.length != 0,
                                  expression:
                                    "myType == 2 && selectMemberNames.length != 0"
                                }
                              ],
                              staticClass: "after-select"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "tip",
                                  on: { click: _vm.showOptions }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.selectOptionShow
                                          ? "折叠筛选条件"
                                          : "展开筛选条件"
                                      )
                                  ),
                                  _c("i", {
                                    staticClass: "btn-icon el-icon-arrow-down",
                                    class: _vm.selectOptionShow
                                      ? "btn-icon2"
                                      : ""
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      ]
                    })
                  ],
                  2
                )
              ]),
              _vm.selectMemberNames.length != 0
                ? _c(
                    "div",
                    { staticClass: "select-wrap" },
                    _vm._l(_vm.selectMemberNames, function(item, index) {
                      return _c(
                        "el-tag",
                        {
                          key: index,
                          attrs: { size: "small", closable: "" },
                          on: {
                            close: function($event) {
                              return _vm.delSelectedHandle(item)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(item.name) + " ")]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm.myType == 5
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "span",
                      {
                        staticClass: "required",
                        staticStyle: { color: "white" }
                      },
                      [_vm._v("*")]
                    ),
                    _c("span", { staticClass: "label" }, [_vm._v("服务客户")]),
                    _c("div", [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectMemberNames.length == 0,
                              expression: "selectMemberNames.length == 0"
                            }
                          ],
                          staticClass: "before-select"
                        },
                        [_vm._v(" 选择员工后，自动生成所对应的客户 ")]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectMemberNames.length != 0,
                              expression: "selectMemberNames.length != 0"
                            }
                          ],
                          staticClass: "after-select"
                        },
                        [
                          _c("div", [
                            _vm._v(
                              "预计触达" + _vm._s(_vm.selecCusNum) + "位客户"
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "tip",
                              on: { click: _vm.showOptions }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.selectOptionShow
                                      ? "折叠筛选条件"
                                      : "展开筛选条件"
                                  )
                              ),
                              _c("i", {
                                staticClass: "btn-icon el-icon-arrow-down",
                                class: _vm.selectOptionShow ? "btn-icon2" : ""
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm.myType == 5 || _vm.myType == 2
                ? _c("el-collapse-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.selectMemberNames.length != 0 &&
                              _vm.selectOptionShow,
                            expression:
                              "selectMemberNames.length != 0 && selectOptionShow"
                          }
                        ]
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "option-container" },
                          [
                            _c("SelectContain", {
                              ref: "selectContain",
                              on: { selectOptions: _vm.selectOptions }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row" }, [
                _c("span", { staticClass: "required" }, [_vm._v("*")]),
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.myType == 5 ? "发送内容" : "任务详情"))
                ])
              ]),
              _c(
                "div",
                { staticClass: "task-detail" },
                [
                  _vm._t("taskDetail", function() {
                    return [
                      _vm.myType == 1
                        ? [
                            _c(
                              "div",
                              { staticClass: "detial-item" },
                              [
                                _vm._v(" 通过好友 "),
                                _c("el-input", {
                                  staticClass: "number-input",
                                  staticStyle: { width: "80px" },
                                  attrs: {
                                    type: "number",
                                    size: "small",
                                    min: 0,
                                    oninput:
                                      "value=value.replace(/[^0-9.]/g,'')"
                                  },
                                  model: {
                                    value: _vm.hours,
                                    callback: function($$v) {
                                      _vm.hours = $$v
                                    },
                                    expression: "hours"
                                  }
                                }),
                                _vm._v(" 小时 "),
                                _c("el-input", {
                                  staticClass: "number-input",
                                  staticStyle: { width: "80px" },
                                  attrs: {
                                    type: "number",
                                    size: "small",
                                    min: 0,
                                    oninput:
                                      "value=value.replace(/[^0-9.]/g,'')"
                                  },
                                  model: {
                                    value: _vm.minute,
                                    callback: function($$v) {
                                      _vm.minute = $$v
                                    },
                                    expression: "minute"
                                  }
                                }),
                                _vm._v(" 分钟 后发送 ")
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm.myType == 2
                        ? [
                            _c(
                              "div",
                              { staticClass: "detial-item" },
                              [
                                _c(
                                  "span",
                                  [
                                    _vm._v(" 发送时间：客户生日前 "),
                                    _c("el-input", {
                                      staticStyle: {
                                        width: "100px",
                                        margin: "0 5px"
                                      },
                                      attrs: {
                                        size: "small",
                                        min: "0",
                                        type: "number",
                                        oninput:
                                          "value=value.replace(/[^0-9.]/g,'')"
                                      },
                                      model: {
                                        value: _vm.params2.daysAgo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.params2, "daysAgo", $$v)
                                        },
                                        expression: "params2.daysAgo"
                                      }
                                    }),
                                    _vm._v("天")
                                  ],
                                  1
                                ),
                                _c("el-time-picker", {
                                  staticStyle: {
                                    width: "100px",
                                    margin: "0 12px"
                                  },
                                  attrs: {
                                    format: "HH:mm",
                                    "value-format": "HH:mm",
                                    size: "small",
                                    clearable: false,
                                    "picker-options": {
                                      selectableRange: _vm.DisApplyTimeHours
                                    },
                                    placeholder: "选择08:35之前"
                                  },
                                  model: {
                                    value: _vm.params2.sendTime,
                                    callback: function($$v) {
                                      _vm.$set(_vm.params2, "sendTime", $$v)
                                    },
                                    expression: "params2.sendTime"
                                  }
                                }),
                                _vm._v(" 发送 "),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: "将于客户公历生日当天发送祝福",
                                      placement: "top-start"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-question icon-style"
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm.myType == 3
                        ? [
                            _c("div", { staticClass: "detial-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("起止时间")
                              ]),
                              _c(
                                "div",
                                [
                                  _c("el-date-picker", {
                                    staticStyle: {
                                      width: "240px",
                                      "margin-right": "10px"
                                    },
                                    attrs: {
                                      size: "small",
                                      editable: false,
                                      type: "datetimerange",
                                      "value-format": "yyyy-MM-dd HH:mm",
                                      format: "yyyy-MM-dd HH:mm",
                                      "default-time": _vm.defaultTime,
                                      "range-separator": "~",
                                      "start-placeholder": "开始时间",
                                      "end-placeholder": "结束时间",
                                      clearable: "",
                                      "picker-options": _vm.pickerOptions
                                    },
                                    on: { change: _vm.selectTime },
                                    model: {
                                      value: _vm.searchSelectTime,
                                      callback: function($$v) {
                                        _vm.searchSelectTime = $$v
                                      },
                                      expression: "searchSelectTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e()
                    ]
                  }),
                  _c("MyUpload", {
                    ref: "myUpload",
                    attrs: { myType: _vm.myType },
                    on: { receiveParam: _vm.receiveParam }
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { size: "small " },
                  on: { click: _vm.closeDialog }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    disabled: !_vm.confirDisable
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmWeicome()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _c("StaffTree", {
        ref: "myStaffTree",
        attrs: {
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.selectMember,
          title: "选择员工"
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }